import saleOutbound from './sale-outbound';
import reportCenter from './report-center';
import inventoryManagement from './inventory-management';
import inbound from './inbound';
import rms from './rms';
import mtInbound from './mt-inbound';
import mtOutbound from './mt-outbound';
import print from './print';

export default [
  ...saleOutbound,
  ...inbound,
  ...reportCenter,
  ...inventoryManagement,
  ...rms,
  ...mtInbound,
  ...mtOutbound,
  ...print,
];
